const steps = [
  { num: 1, label: 'Build', desc: 'Define strategy rules and parameters' },
  { num: 2, label: 'Backtest', desc: 'Simulate on historical data' },
  { num: 3, label: 'Optimize', desc: 'Explore parameter sensitivity' },
  { num: 4, label: 'Walk-Forward', desc: 'Out-of-sample validation' },
  { num: 5, label: 'Validate', desc: 'Confirm robustness before going live' },
];

export default function ResearchWorkflowMock() {
  return (
    <div className="platform-mock">
      <div className="platform-mock-header"><span className="dot" /> Strategy Research Workflow</div>
      <div className="platform-mock-body">
        <div className="mock-steps">
          {steps.map((s, i) => (
            <span key={s.num} style={{ display: 'contents' }}>
              {i > 0 && <div className="mock-step-arrow">&rarr;</div>}
              <div className="mock-step">
                <div className="mock-step-num">{s.num}</div>
                <div className="mock-step-label">{s.label}</div>
                <div className="mock-step-desc">{s.desc}</div>
              </div>
            </span>
          ))}
        </div>
      </div>
      <div className="platform-mock-caption">Backtesting is step two. The real work is everything that comes after it.</div>
    </div>
  );
}
